module.exports = __webpack_public_path__ + "img/rek_52fc265.webp";